import { writable } from 'svelte/store';
import { getCookie } from '../utils/cookies'


function createUserStatusStore() {

    const { subscribe, set, update } = writable({loggedin: false, initialized: false});

    return {
        subscribe,
        authentify: function(l,p, url=null) {

            fetch(
                '/sanctum/csrf-cookie',
                {
                    method: "GET",
                    'credentials': "include"
                }
            )
            .then(r => {
                let fd = new FormData();
                fd.append( "email", l );
                fd.append( "password", p );

                fetch('/api/patient/login',
                    {
                        method: "POST",
                        credentials: 'include',
                        headers: {
                            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN"),
                            "Accept": "application/json"
                        },
                        body: fd
                    }).then(r => r.json())
                .then(r => {
                    if (r.success) {
                        update(function(old) {
                            return {
                                logged_in: true,
                                initialized: true,
                                details: r.data.details
                            }
                        });
                        if (url!=null) location.href=url;
                    } else {
                        update(function(old) {
                            return {
                                logged_in: false,
                                initialized: true,
                                error: r.message
                            }
                        });
                    }
                })
            });
        },
        check_logged_in: function(l,p, url=null) {

            fetch(
                '/sanctum/csrf-cookie',
                {
                    method: "GET",
                    'credentials': 'include'
                }
            ).then(r => {
                update(function (old) {
                    return {
                        logged_in: false,
                        initialized: true,
                    }
                });


                if (true) {
                    fetch('/api/patient/login')
                    .then(r => r.json())
                    .then(r => {
                        if (r.success) {
                            update(function (old) {
                                return {
                                    logged_in: true,
                                    initialized: true,
                                    details: r.data.details
                                }
                            });
                            if (url!=null) location.href = url;
                        } else {
                            update(function (old) {
                                return {
                                    logged_in: false,
                                    initilized: true
                                }
                            });
                        }
                    })

                }



            });
        },
        change_password: function (current_password, new_password) {
            if(new_password=="") return new Promise((resolve, reject) => resolve({success: false, error: "Le nouveau mot de passe doit être fourni"}));
            return fetch('/api/patient/password',
            {
                method: "PUT",
                credentials: 'include',
                headers: {
                    "X-XSRF-TOKEN": getCookie("XSRF-TOKEN"),
                    "Accept": "application/json"
                },
                body: JSON.stringify({current_password: current_password, new_password: new_password})
            }).then(r => r.json());

        },
        logout: function(url=null) {
            fetch('/api/logout')
            .then(r => r.json())
            .then(r => {
                update(function(d) {
                    return {
                        logged_in: false,
                        initialized: true,
                    };
                });
                if (url!=null) location.href = url;
            });
        },
        reset: function() {
            update(function(old) {
                return {
                    logged_in: old.logged_in
                }
            });
        },
        set_error: function(message) {
            update(function(old) {
                return {
                    logged_in: old.logged_in,
                    initialized: old.initialized,
                    error: message
                }
            });

        }
    }
}

export const user = createUserStatusStore();